import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import { useParams, useHistory } from "react-router-dom";
import 'react-calendar/dist/Calendar.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import DropDownTable from '../../Shared/DropDownTable';
import UploadFile from '../../Shared/UploadFile';
import Input from '../../Shared/Input';
import '../../../css/GenericServices/UpdateResponseForm.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import calender from '../../../Assets/ProfileManagement/Assets-Desktop/calender.svg';
import SuccessModal from '../../Shared/SuccessModal';
import { masterJson } from '../../../Data/GenericServices/updateResponseFormData';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, servicecatalogBaseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import { uiFieldsMetaData_ENDPOINT, SERVICE_REQUEST_ENDPOINT, LOOKUP_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { useSelector } from 'react-redux';
let headerServiceName = "", serviceIDValue = 0;
const UpdateResponseForm = (props) => {
    const paramObj = useParams();
    let history = useHistory();
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    const container = React.createRef();
    const [errors, setErrors] = useState({});
    const [editableMode, setEditTable] = useState(true);
    const [filePathRefDoc, setFilepathRefDoc] = useState('');
    const [loaderTime, setLoaderTime] = useState('')
    const [pageDisable, setPageDisable] = useState('');
    let [fileUpload1Error, setFileUpload1Error] = useState();
    const [commodityDropDown, setCommodityDropDown] = useState([]);
    const [textLength, setTextLength] = useState([]);
    const [Commoditydata, setCommoditydata] = useState([{ name: "Bulk Bags" }, { name: "Bulk Cargo" }, { name: "Bundled Steel/Timber" }])
    const [CommoditydataValues, setCommoditydataValues] = useState([{ name: "ABC" }, { name: "XYZ" }, { name: "ABCD" }])
    const [values, setValues] = useState([]);
    const [dropDownIndex, setDropDownIndex] = useState('');
    const [dropDownRecord, setDropDownRecord] = useState([]);
    const [hasOpenSuccess, setHasOpenSuccess] = useState(false);
    const [tempValues, setTempValues] = useState([]);
    const [filterJson, setFilterJson] = useState([
        // {
        //     "fieldId": 1001,
        //     "fieldName": "startDateTime",
        //     "displayName": "Start Date & Time",
        //     "inputType": "calendarDateTime",
        //     "dropDownData": "",
        //     "validationType": "",
        //     "requiredField": "yes",
        //     "isEdit": true,
        //     "fieldLookup": ""
        // },
        // {
        //     "fieldId": 1002,
        //     "fieldName": "endDateTime",
        //     "displayName": "End Date & Time",
        //     "inputType": "calendarDateTime",
        //     "dropDownData": "",
        //     "validationType": "",
        //     "requiredField": "yes",
        //     "isEdit": true,
        //     "fieldLookup": ""
        // },
        // {
        //     "fieldId": 1003,
        //     "fieldName": "rfqDateTime",
        //     "displayName": "RFQ Date & Time",
        //     "inputType": "calendarDateTime",
        //     "dropDownData": "",
        //     "validationType": "",
        //     "requiredField": "yes",
        //     "isEdit": true,
        //     "fieldLookup": ""
        // }
    ]);
    const [calendarDate, setCalendarDate] = useState([]);
    const [calendarHour, setCalendarHour] = useState([]);
    const [calendarMin, setCalendarMin] = useState([]);
    const [dateToggle, setDateToggle] = useState([]);
    const [hourToggle, setHourToggle] = useState([]);
    const [minToggle, setMinToggle] = useState([]);
    const hourValues = [{ hour: "00" }, { hour: "01" }, { hour: "02" }, { hour: "03" }, { hour: "04" }, { hour: "05" }, { hour: "06" }, { hour: "07" }, { hour: "08" }, { hour: "09" },
    { hour: "10" }, { hour: "11" }, { hour: "12" }, { hour: "13" }, { hour: "14" }, { hour: "15" }, { hour: "16" }, { hour: "17" }, { hour: "18" }, { hour: "19" },
    { hour: "20" }, { hour: "21" }, { hour: "22" }, { hour: "23" }];
    const minValues = [{ minit: "00" }, { minit: "01" }, { minit: "02" }, { minit: "03" }, { minit: "04" }, { minit: "05" }, { minit: "06" }, { minit: "07" }, { minit: "08" }, { minit: "09" },
    { minit: "10" }, { minit: "11" }, { minit: "12" }, { minit: "13" }, { minit: "14" }, { minit: "15" }, { minit: "16" }, { minit: "17" }, { minit: "18" }, { minit: "19" },
    { minit: "20" }, { minit: "21" }, { minit: "22" }, { minit: "23" }, { minit: "24" }, { minit: "25" }, { minit: "26" }, { minit: "27" }, { minit: "28" }, { minit: "29" },
    { minit: "30" }, { minit: "31" }, { minit: "32" }, { minit: "33" }, { minit: "34" }, { minit: "35" }, { minit: "36" }, { minit: "37" }, { minit: "38" }, { minit: "39" },
    { minit: "40" }, { minit: "41" }, { minit: "42" }, { minit: "43" }, { minit: "44" }, { minit: "45" }, { minit: "46" }, { minit: "47" }, { minit: "48" }, { minit: "49" },
    { minit: "50" }, { minit: "51" }, { minit: "52" }, { minit: "53" }, { minit: "54" }, { minit: "55" }, { minit: "56" }, { minit: "57" }, { minit: "58" }, { minit: "59" }];
    const handleClickOutside = event => {
        if (container.current && !container.current.contains(event.target)) {
            let a = commodityDropDown;
            a[dropDownIndex] = false;
            setCommodityDropDown(a);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);
    var getDataBody = {
    }
    const getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    const getTimeFormated = (timeStamp) => {
        if (timeStamp) {
            return new Date(Number(timeStamp)).toGMTString().split(' ')[4].substring(0, 5)
        }
    }
    useEffect(() => {
        const { serviceId, serviceName } = paramObj;
        headerServiceName = serviceName;
        serviceIDValue = parseInt(serviceId);
        getRequestDetails(serviceId);
    }, [])
    const getRequestDetails = (serviceId) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?roleType=${manageProfileDataR?.selectedProfileType}&serviceRequestId=${serviceId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("in 500");
                }
                else {
                    console.log('I am 200!');
                    getDataBody = data?.serviceRequestData;
                    getDataBody.startDateTime = data?.requestSummary?.serviceDetail?.startDateTime;
                    getDataBody.endDateTime = data?.requestSummary?.serviceDetail?.endDateTime;
                    getDataBody.requestClosingDate = data?.requestSummary?.serviceDetail?.rfqDateTime;
                    getDataBody.payment_terms = data?.requestSummary?.serviceDetail?.payment_terms;

                    var serviceNameType = headerServiceName.replace("&", "%26");
                    ApiCall(
                        'GET',
                        servicecatalogBaseURL + uiFieldsMetaData_ENDPOINT + `?serviceName=${serviceNameType}`,
                        {},
                        {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    ).then((apiData) => {
                        if (apiData.flag != -1) {
                            if (apiData.flag == 500) {
                                console.log('I am 500!');
                            }
                            else {
                                console.log('I am 200!');
                                let temp = filterJson;
                                let dropv = [];
                                apiData?.find((x, i) => {
                                    masterJson.forEach((data, index) => {
                                        if (data.fieldId == x.fieldId) {
                                            temp.push({
                                                fieldId: x.fieldId,
                                                fieldName: x.fieldName,
                                                displayName: x.displayName,
                                                inputType: x.entryType == "Drop Down" ? "dropdown" : data.inputType,
                                                dropDownData: [],
                                                validationType: data.validationType,
                                                requiredField: x.fieldType?.toLowerCase() == "mandatory" ? "yes" : "",
                                                isEdit: data.isEdit,
                                                fieldLookup: x.fieldLookup,
                                            })
                                            dropv.push(false);
                                        }
                                    })
                                })
                                temp.push(
                                    {
                                        "fieldId": 1001,
                                        "fieldName": "startDateTime",
                                        "displayName": "Start Date & Time",
                                        "inputType": "calendarDateTime",
                                        "dropDownData": "",
                                        "validationType": "",
                                        "requiredField": "yes",
                                        "isEdit": true,
                                        "fieldLookup": ""
                                    },
                                    {
                                        "fieldId": 1002,
                                        "fieldName": "endDateTime",
                                        "displayName": "End Date & Time",
                                        "inputType": "calendarDateTime",
                                        "dropDownData": "",
                                        "validationType": "",
                                        "requiredField": "yes",
                                        "isEdit": true,
                                        "fieldLookup": ""
                                    },
                                    {
                                        "fieldId": 1003,
                                        "fieldName": "requestClosingDate",
                                        "displayName": "Request Closing Date",
                                        "inputType": "calendarDate",
                                        "dropDownData": "",
                                        "validationType": "",
                                        "requiredField": "yes",
                                        "isEdit": true,
                                        "fieldLookup": ""
                                    },
                                    {
                                        "fieldId": 1004,
                                        "fieldName": "payment_terms",
                                        "displayName": "Payment Terms",
                                        "inputType": 'dropdown',
                                        "dropDownData": "",
                                        "validationType": '',
                                        "requiredField": "yes",
                                        "isEdit": true,
                                        "fieldLookup": "F_PAYMENT_TERMS",
                                        // "fieldDataType": "varchar",
                                        // "fieldLength": 50,
                                        // "entryType": "Drop Down",

                                        // "comments": "",




                                    },
                                );
                                setFilterJson(temp);
                                setCommodityDropDown(dropv);
                                let fieldNameTemp = '';
                                let getDetails = [];
                                for (let index = 0; index < temp.length; index++) {
                                    fieldNameTemp = temp[index].fieldName;
                                    Object.keys(getDataBody).map((name, i) => {
                                        if (name == fieldNameTemp) {
                                            let val1 = Object.values(getDataBody)[i];
                                            if (temp[index].inputType == 'calendarDate') {
                                                calendarDate[index] = getDateFormated(val1);
                                                setCalendarDate(calendarDate);
                                            }
                                            else if (temp[index].inputType == 'calendarDateTime') {
                                                calendarDate[index] = getDateFormated(val1);
                                                setCalendarDate(calendarDate);
                                                calendarHour[index] = getTimeFormated(val1).split(':')[0];
                                                setCalendarHour(calendarHour);
                                                calendarMin[index] = getTimeFormated(val1).split(':')[1];
                                                setCalendarMin(calendarMin);
                                            }
                                            getDetails.push(val1);
                                        }
                                    });
                                    console.log('abc--', Object.values(getDataBody)[0]);
                                }
                                setValues(getDetails);
                                console.log('getData', getDetails);
                            }
                        }
                    });
                }
            }
        });
    }
    const isCalenderDateValidate = (obj) => {
        let isValid = true
        if (isValid) {
            let errors = {};
            let isRFQValid = obj?.requestClosingDate < obj?.startDateTime;
            let isStartValid = (obj?.requestClosingDate < obj?.startDateTime) && (obj?.startDateTime < obj?.endDateTime);
            let isEndValid = obj?.endDateTime > obj?.startDateTime;
            if (!isRFQValid) {
                for (let index = 0; index < filterJson.length; index++) {
                    if (filterJson[index].fieldName == "requestClosingDate") {
                        errors[filterJson[index].displayName] = 'Must be before Service Start Date';
                        document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                    }
                }
                setErrors(errors);
            }
            if (!isStartValid) {
                for (let index = 0; index < filterJson.length; index++) {
                    if (filterJson[index].fieldName == "startDateTime") {
                        errors[filterJson[index].displayName] = 'Must be between Request Closing and Service End Date';
                        document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                    }
                }
                setErrors(errors);
            }
            if (!isEndValid) {
                for (let index = 0; index < filterJson.length; index++) {
                    if (filterJson[index].fieldName == "endDateTime") {
                        errors[filterJson[index].displayName] = 'Must be after Service Start Date';
                        document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                    }
                }
                setErrors(errors);
            }
            isValid = isValid && isRFQValid && isStartValid && isEndValid;
            return isValid;
        }
    }
    const postCall = () => {
        const tempData = [];
        const obj = {};
        for (let index = 0; index < filterJson.length; index++) {
            const element = values[index];
            const fieldNameTempp = filterJson[index].fieldName;
            obj[fieldNameTempp] = element;
        }
        tempData.push(obj);
        console.log('obj', obj);
        console.log('startDateTime', obj.startDateTime);
        const cDataObj = JSON.parse(JSON.stringify(obj));
        delete cDataObj.startDateTime;
        delete cDataObj.endDateTime;
        delete cDataObj.requestClosingDate;
        delete cDataObj.payment_terms;
        console.log('cData', cDataObj)
        if (isCalenderDateValidate(obj)) {
            ApiCall(
                'PUT',
                serviceBaseURL + SERVICE_REQUEST_ENDPOINT,
                {
                    "requestData": {
                        "baseService": {
                            "endDateTime": parseInt(obj?.endDateTime),
                            "location": "",
                            "publishDateTime": new Date().getTime(),
                            "requestorCompanyName": "",
                            "rfqDateTime": parseInt(obj?.requestClosingDate),
                            "serviceId": serviceIDValue,
                            "serviceName": headerServiceName,
                            "serviceType": headerServiceName,
                            "startDateTime": parseInt(obj?.startDateTime),
                            "status": "Open",
                            "paymentTerm": obj?.payment_terms
                        },
                        "fieldsData": cDataObj,
                        "docPath": ""
                    },
                    "serviceRequestId": serviceIDValue
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        setEditTable(false);
                        setHasOpenSuccess(true);
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }
    }
    const handleChangeInput = (e, index, displayName) => {
        if (filterJson[index].inputType == 'inputWithLimit' && e.target.value.length <= 500) {
            textLength[index] = e.target.value.length;
            setTextLength(textLength);
            console.log('err text', textLength);
            values[index] = e.target.value;
            setValues(values);
            let var1 = errors[displayName] = '';
            console.log('error-', errors);
            setErrors({ ...errors, var1 })
            document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
        } else {
            console.log('err displa', displayName);
            values[index] = e.target.value;
            setValues(values);
            let var1 = errors[displayName] = '';
            console.log('error-', errors);
            setErrors({ ...errors, var1 })
            document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    const validate = () => {
        let errors = {};
        let formIsValid = true;
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var patternAlphaNumeric = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/);
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].isEdit && editableMode) {
                const element = values[index];
                if (!element && filterJson[index].requiredField == 'yes') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.required;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (element && !patternCharacter.test(element) && filterJson[index].validationType == 'alpha') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.alpha;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (element && !patternDigit.test(element) && filterJson[index].validationType == 'num') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.num;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (element && !patternAlphaNumeric.test(element) && filterJson[index].validationType == 'alphanum') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.alphanum;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else {
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.black;
                }
                //upload file border only
                if (filterJson[index].inputType == 'upload' && !element && filterJson[index].requiredField == 'yes') {
                    document.getElementById(filterJson[index].displayName).style.borderColor = ColorCode.colorCode.red;
                }
                else if (filterJson[index].inputType == 'upload' && element) {
                    document.getElementById(filterJson[index].displayName).style.borderColor = ColorCode.colorCode.black;
                }
                // calender time and min border only
                if (filterJson[index].inputType == 'calendarDateTime' && !element && filterJson[index].requiredField == 'yes') {
                    document.getElementsByName(filterJson[index].fieldName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (filterJson[index].inputType == 'calendarDateTime' && element) {
                    document.getElementsByName(filterJson[index].fieldName)[0].style.borderColor = ColorCode.colorCode.black;
                }
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    const toggleDropDown = (index) => {
        setDropDownIndex(index);
        const element = commodityDropDown[index];
        let var2 = !element;
        commodityDropDown[index] = !element;
        console.log('dropdown', index, commodityDropDown);
        setCommodityDropDown({ ...commodityDropDown, var2 });
        var dropData = [];
        setDropDownRecord(dropData);
        var lookupType = filterJson[index]?.fieldLookup;
        console.log("type-", lookupType)
        ApiCall(
            'GET',
            utilityBaseURL + LOOKUP_ENDPOINT + `?lookupType=${lookupType}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setDropDownRecord(data);
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    };
    const toggleDate = (index) => {
        const element = dateToggle[index];
        let var2 = !element;
        dateToggle[index] = !element;
        console.log('dropdown', index, dateToggle);
        setDateToggle({ ...dateToggle, var2 });
    }
    const toggleHour = (index) => {
        const element = hourToggle[index];
        let var2 = !element;
        hourToggle[index] = !element;
        console.log('dropdown', index, hourToggle);
        setHourToggle({ ...hourToggle, var2 });
    }
    const toggleMin = (index) => {
        const element = minToggle[index];
        let var2 = !element;
        minToggle[index] = !element;
        console.log('dropdown', index, minToggle);
        setMinToggle({ ...minToggle, var2 });
    }
    const onContinue = () => {
        console.log('before validate-', values);
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].inputType == 'calendarDateTime') {
                let fromTimeStamp = new Date(calendarDate[index]).toString().substring(4, 15) + ' '
                    + calendarHour[index] + ':' + calendarMin[index];
                values[index] = Date.parse(fromTimeStamp);
                setValues(values);
            } else if (filterJson[index].inputType == 'calendarDate') {
                let fromTimeStamp = new Date(calendarDate[index]).toString().substring(4, 15);
                values[index] = Date.parse(fromTimeStamp);
                setValues(values);
            }
        }
        console.log('validate-', values);
        if (validate()) {
            console.log('submit val-', values);
            postCall();
        }
    }
    const changeDropDownValue = (e, index) => {
        const found = dropDownRecord?.find((name) => {
            if (name?.lookupCode === e.target.innerText) {
                return name
            }
        })
        values[index] = found?.lookupCode;
        setValues(values);
        const element = commodityDropDown[index];
        let var2 = !element;
        commodityDropDown[index] = !element;
        console.log('dropdown', index, commodityDropDown);
        setCommodityDropDown({ ...commodityDropDown, var2 });
        console.log('val--', values)
        let displayName = filterJson[index].displayName;
        let var1 = errors[displayName] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
    }
    const removeUpdateReferenceDocumentsLink = () => {
        let path = "";
        setFilepathRefDoc(path);
    }
    const setUploadLinkUpdateReferenceDocuments = (filePathURL) => {
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].inputType == 'upload') {
                values[index] = filePathURL;
                setValues(values);
            }
        }
        setFilepathRefDoc(filePathURL);
        setLoaderTime(false);
        setPageDisable(false);
    }
    const setLoaderUpdateReferenceDocuments = (filePathURL) => {
        setLoaderTime(filePathURL);
        setPageDisable(filePathURL);
    }
    const handleChangeDate = (e, index, fieldId) => {
        calendarDate[index] = getDateFormated(e);
        setCalendarDate(calendarDate);
        console.log('cale--', calendarDate);
        const element = dateToggle[index];
        let var2 = !element;
        dateToggle[index] = !element;
        console.log('dropdown', index, dateToggle);
        setDateToggle({ ...dateToggle, var2 });
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        if (fieldId == 1001) {
            let minDateValue = new Date(e.getTime() + (1000 * 60 * 60 * 24));
            let maxDateValue = new Date(e.getTime() - (1000 * 60 * 60 * 24));
            tempValues.push(minDateValue);
            tempValues.push(maxDateValue);
        }

        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change min and hour boder
        if (filterJson[index].inputType == 'calendarDateTime') {
            let fieldNameTemp = filterJson[index].fieldName;
            document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    const onCloseModal = () => {
        setHasOpenSuccess(false);
        history.push({
            pathname: `/TransportationServiceGS/${serviceIDValue}/${headerServiceName}`
        });
    };
    const handleChangeHour = (e, index) => {
        const found = hourValues.find((name) => {
            if (name.hour === e.target.innerText) {
                return name
            }
        })
        calendarHour[index] = found.hour;
        setCalendarHour(calendarHour);
        console.log('hour', calendarHour)
        const element = hourToggle[index];
        let var2 = !element;
        hourToggle[index] = !element;
        console.log('dropdown', index, hourToggle);
        setHourToggle({ ...hourToggle, var2 });
        let fieldNameTemp = filterJson[index].fieldName;
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change calender date border
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeMin = (e, index) => {
        const found = minValues.find((name) => {
            if (name.minit === e.target.innerText) {
                return name
            }
        })
        calendarMin[index] = found.minit;
        setCalendarMin(calendarMin);
        const element = minToggle[index];
        let var2 = !element;
        minToggle[index] = !element;
        console.log('dropdown', index, minToggle);
        setMinToggle({ ...minToggle, var2 });
        let fieldNameTemp = filterJson[index].fieldName;
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change calender date border
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
    }
    return (
        <div class="UpdateResponseFormOutercolor">
            <MetaDecorator title={TitleDescription.UpdateServiceRequestGSTitle} description={TitleDescription.UpdateServiceRequestGSDescription} />
            <Header tilesFetched={() => { }} />
            <div class="UpdateResponseFormOuterDivcss">
                <div id="UpdateResponseFormBoxDiv">
                    <nav class="UpdateResponseFormNavbar">
                        <div className="UpdateResponseFormNavbarName">
                            <small id="UpdateResponseFormNavbarText">{headerServiceName}</small>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <div class="UpdateResponseFormMidPartition">
                        <div class="UpdateResponseFormHeadingText">Service Request Details</div>
                        <div class="UpdateResponseFormCardcss">
                            {filterJson.map((name, index) => {
                                return (
                                    <>
                                        {(name.inputType == 'input' || name.inputType == 'inputWithLimit') &&
                                            <div class="UpdateResponseFormInpSize">
                                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                                {(name.isEdit && editableMode) ?
                                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                                        <Input
                                                            name={name.displayName}
                                                            class="input UpdateResponseFormInpCss" placeholder={`Enter ${name.displayName}`}
                                                            type="text" id={name.displayName} value={values[index]}
                                                            onChange={(e) => handleChangeInput(e, index, name.displayName)}
                                                        />
                                                        <div className="UpdateResponseFormError">{errors[name.displayName]}</div>
                                                        {name.inputType == 'inputWithLimit' &&
                                                            <small class="UpdateResponseFormCommentTextlmt">{textLength[index] ? textLength[index] : 0}/500</small>
                                                        }
                                                    </div>
                                                    :
                                                    <div class="UpdateResponseFormRLowerText">{values[index]} </div>
                                                }
                                            </div>
                                        }
                                        {name.inputType == 'dropdown' &&
                                            <div class="UpdateResponseFormInpSize">
                                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                                {(name.isEdit && editableMode) ?
                                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                                        <Input
                                                            readOnly
                                                            name={name.displayName} placeholder={`Select ${name.displayName}`}
                                                            type="text" class={commodityDropDown[index] ? "UpdateResponseFormBtmBorderLessCss input" : "UpdateResponseFormInpDropCss input"}
                                                            value={values[index]}
                                                        />
                                                        <div className="UpdateResponseFormDropError">{errors[name.displayName]}</div>
                                                        <i id="UpdateResponseFormInp_imgDrop" onClick={() => toggleDropDown(index)}>
                                                            <img src={commodityDropDown[index] ? uparrow : downarrow} />
                                                        </i>
                                                    </div>
                                                    :
                                                    <div class="UpdateResponseFormRLowerText">{values[index]} </div>
                                                }
                                                {commodityDropDown[index] && (
                                                    <div class="UpdateResponseFormDropDowmDiv" >
                                                        <div class="UpdateResponseFormDropCard" ref={container} >
                                                            {(dropDownRecord?.map((data, i) => {
                                                                return (
                                                                    <DropDownTable id="UpdateResponseFormDropRowSize" onClick={(e) => changeDropDownValue(e, index)}>
                                                                        <small class="" id="UpdateResponseFormDropRowText" >{data?.lookupCode} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        }
                                        {name.inputType == 'upload' &&
                                            <div class="UpdateResponseFormInpSize">
                                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                                {(name.isEdit && editableMode) ?
                                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                                        <UploadFile uploaddivid={name.displayName} idupload="upload"
                                                            name={name.displayName}
                                                            fileType="jpeg, jpg, png, pdf"
                                                            removeLink={removeUpdateReferenceDocumentsLink}
                                                            upload_link="cipcUpload" uploadicon="cipcIcon"
                                                            setFileLink={setUploadLinkUpdateReferenceDocuments}
                                                            setLoader={setLoaderUpdateReferenceDocuments}
                                                            staticFileName={'Update_Reference_Documents.'}
                                                        />
                                                        <div className="UpdateResponseFormError">{errors[name.displayName]}</div>
                                                    </div>
                                                    :
                                                    <div class="UpdateResponseFormRLowerText">{values[index]} </div>
                                                }
                                            </div>
                                        }
                                        {(name.inputType == 'calendarDateTime' || name.inputType == 'calendarDate') &&
                                            <div class="UpdateResponseFormInpSize">
                                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                                {(name.isEdit && editableMode) ?
                                                    <div id="UpdateResponseFormCalOuterDiv">
                                                        <div className="pass-wrapper"
                                                            id={name.inputType == 'calendarDate' ? "UpdateResponseFormInpDiv" : "UpdateResponseFormCalendarDiv"}>
                                                            <input
                                                                readOnly
                                                                class="inpuut1 UpdateResponseFormCalSWCss"
                                                                placeholder="Select Date"
                                                                type="text"
                                                                id={name.fieldName}
                                                                name={name.displayName}
                                                                autoComplete="off"
                                                                value={calendarDate[index]}
                                                            />
                                                            <div className={(name.inputType == 'calendarDateTime') ? "UpdateResponseFormDropError CreateResponseFormCalWidthCss" : "UpdateResponseFormDropError"}>{errors[name.displayName]}</div>
                                                            <div class="UpdateResponseFormSWCalendarWidth">  {dateToggle[index] ?
                                                                <div ref={container}>
                                                                    <Calendar onChange={(e) => handleChangeDate(e, index, name.fieldId)}
                                                                        minDate={tempValues?.length == 0 ? new Date() : (name.fieldName == "endDateTime" ? tempValues[0] : new Date())}
                                                                        maxDate={name.fieldName == "requestClosingDate" ? tempValues[1] : null}
                                                                    />
                                                                </div> : null}
                                                            </div>
                                                            <img id={name.inputType == 'calendarDate' ? "UpdateResponseFormInp_imgCal" : "UpdateResponseFormSWCal_imgCal"}
                                                                src={calender} alt="" onClick={() => toggleDate(index)}
                                                            />
                                                        </div>
                                                        {name.inputType == 'calendarDateTime' &&
                                                            <div id={hourToggle[index] ? "UpdateResponseFormHourDiv" : (minToggle[index] ? "UpdateResponseFormMinitDiv" : "UpdateResponseFormHTDiv")} name={name.fieldName}>
                                                                <div id="UpdateResponseFormHHDiv" >
                                                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                                                        <Input
                                                                            readOnly name="SWStartHour" class="UpdateResponseFormHTDropCss" placeholder="HH"
                                                                            type="text"
                                                                            value={calendarHour[index]}
                                                                        />
                                                                        <i id="UpdateResponseFormHHMM_imgDrop" onClick={() => toggleHour(index)}>
                                                                            {hourToggle[index] ? <img src={uparrow} /> : <img src={downarrow} />}
                                                                        </i>
                                                                    </div>
                                                                    {hourToggle[index] && (
                                                                        <div class="UpdateResponseFormDropDowmDiv" >
                                                                            <div class="UpdateResponseFormHMDropCard" ref={container} >
                                                                                {(hourValues?.map((hourV, i) => {
                                                                                    return (
                                                                                        <DropDownTable onClick={(e) => handleChangeHour(e, index)} id="UpdateResponseFormHHMMRowSize">
                                                                                            <small class="" id="UpdateResponseFormDropRowText" >{hourV.hour} </small>
                                                                                        </DropDownTable>
                                                                                    );
                                                                                }))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div id="UpdateResponseFormTTDiv">
                                                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                                                        <Input
                                                                            readOnly name="SWStartMinit" class="UpdateResponseFormHTDropCss" placeholder="MM"
                                                                            type="text"
                                                                            value={calendarMin[index]}
                                                                        />
                                                                        <i id="UpdateResponseFormMinit_imgDrop" onClick={() => toggleMin(index)}>
                                                                            {minToggle[index] ? <img src={uparrow} /> : <img src={downarrow} />}
                                                                        </i>
                                                                    </div>
                                                                    {minToggle[index] && (
                                                                        <div class="UpdateResponseFormDropDowmDiv" >
                                                                            <div class="UpdateResponseFormHMDropCard" ref={container} >
                                                                                {(minValues.map((minV, i) => {
                                                                                    return (
                                                                                        <DropDownTable onClick={(e) => handleChangeMin(e, index)} id="UpdateResponseFormHHMMRowSize">
                                                                                            <small class="" id="UpdateResponseFormDropRowText" >{minV.minit} </small>
                                                                                        </DropDownTable>
                                                                                    );
                                                                                }))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    :
                                                    name.inputType == 'calendarDateTime' ?
                                                        <div class="UpdateResponseFormRLowerText">{calendarDate[index]} {calendarHour[index]}:{calendarMin[index]}</div>
                                                        :
                                                        <div class="UpdateResponseFormRLowerText">{calendarDate[index]} </div>
                                                }
                                            </div>
                                        }
                                    </>
                                )
                            })
                            }
                        </div>
                        <div class="UpdateResponseFormBtnDiv">
                            <Button class="UpdateResponseFormBtnCss" onClick={() => onContinue()}>
                                <small class="UpdateResponseFormBtntext">Continue</small>
                            </Button>
                        </div>
                    </div>
                </div>
                <div class="UpdateResponseFormFooterUnfixed">
                    <Footer />
                </div>
                <div class="UpdateResponseFormFooterFixed">
                    <Footer2 />
                </div>
            </div >
            <SuccessModal hasOpen={hasOpenSuccess} onCloseModal={onCloseModal}>
                <div>
                    <div class="successRatingdivout">
                        <small class="successRatingdivsm">Your response has been submitted
                        </small>
                        <small class="successRatingdivsm"> successfully.</small>
                    </div>
                </div>
            </SuccessModal>
        </div>
    )
}
export default UpdateResponseForm;